import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteDocuments } from './normalize';

export const fetchQuoteDocuments = createProvider(api.fetchQuoteDocuments)
  .andThen((res) => normalizeQuoteDocuments(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
